import React from 'react'
import { useNotificationListContext } from './Context'
import { notificationListFieldConfig } from './constants'
import { ListRow } from './ListRow'
import { ListHeader } from './ListHeader'
import { DataTable } from '../../DataTable/DataTable'

export const NotificationList = () => {
  const { notifications, notificationListWithSelection } = useNotificationListContext()
  const { list } = notificationListWithSelection
  const defaultListResult = { ...notifications, list }
  return (
    <DataTable
      listResult={defaultListResult}
      fields={notificationListFieldConfig}
      row={ListRow}
      head={ListHeader}
      stats={'notifications'}
    />
  )
}
